import styled from 'styled-components';

const StyledVideoScrollYoutube = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  text-align: right;
  top: 0;
  .video--wrap{
    position: relative;
    width: 83.33%;
    padding-right: 48px;
    margin-left: 8.33%;
    left: 8.33%;
    bottom: -160px;
    overflow: hidden;
    padding-bottom: 56.25% !important; /* 16:9 */
    height: 0;
  }
  &.right .video--wrap {
    padding-left: 48px;
    padding-right: 0;
    right: 8.33%;
    left: auto;
    margin-left: auto;
    margin-right: 8.33%;
  }
  .video--wrap iframe{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  @media screen and (max-width: 1023px){
    .video--wrap{
      padding-right: 32px;
      bottom: -128px;
    }
    &.right .video--wrap {
      padding-left: 32px;
      padding-right: 0;
    }
  }
  @media screen and (max-width: 1023px){
    .video--wrap{
      margin: 0 auto;
      padding: 0;
      left: inherit;
      bottom: -80px;
    }
    .video--wrap video{
      position: relative;
      height: auto; 
      width: 100%;
      left: 0;
      transform: translateX(0%);
    }
  }
  
`;

export {
  StyledVideoScrollYoutube,
};

